import { useMemo } from "react";

import { type ThemeMode } from "../../../muiThemeTypes";
import { getColors } from "../../../Pages/CloudAnalytics/utilities";

export const useChartColors = (mode: ThemeMode): string[] => useMemo(() => getColors(mode), [mode]);
